import { render, staticRenderFns } from "./TPop.vue?vue&type=template&id=471242c1&scoped=true"
import script from "./TPop.vue?vue&type=script&lang=js"
export * from "./TPop.vue?vue&type=script&lang=js"
import style0 from "./TPop.vue?vue&type=style&index=0&id=471242c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471242c1",
  null
  
)

export default component.exports